import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; 
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../../../layouts/page';
import Submit from '../../../components/button';
import { config } from '../../../config';
import Backbtn from '../../../components/backbtn';
import Editor from '../../../components/editor/index';

const Create = () => {
  const { id} = useParams()
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    service_category_id: id,
    name: '',
    description: '',
  });
  const [loading, setLoading] = useState(false);
 
  useEffect(() => {
    document.title = 'Create Service Sub-Category';
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  
  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setFormData((prevData) => ({
      ...prevData,
      description: data,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const token = localStorage.getItem('auth_token');
    try {
      await axios.post(config.api_path+'/service-sub-categories', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      setLoading(false);
      toast.success('Service sub-category created successfully!');
      setTimeout(() => {
        navigate(-1); // Redirect to the specified route
      }, 2000); // Adjust the delay as necessary

      // Reset the form after successful submission
      setFormData({
        service_category_id: '',
        name: '',
        description: '',
      });
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.message);
      console.error('Submission error:', error);
    }
  };

  return (
    <Layout>
      <div className="col-12 grid-margin">
        <div className="card">
          <div className="card-body">
            <h4>Create Service Sub-Category</h4>
            <Backbtn />
            <form onSubmit={handleSubmit}>
              <div className="row">

                {/* Name */}
                <div className="form-group col-md-6">
                  <label className="col-form-label">
                    Name<span>*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <Editor
                    width="col-md-12"
                    label="Description"
                    value={formData.description}
                    onChange={handleEditorChange}
                  />
              </div>

              {/* Submit Button */}
              <Submit loading={loading} />
            </form>
            <ToastContainer />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Create;
